import React from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { MOCK_STATS_VENDOR } from "../../data/mock";

const SPECIALTIES = ["Visiting Cards", "Brochures", "Flex Boards", "Packaging", "Stickers"];

export default function VendorProfile() {
  const { user } = useAuth();
  return (
    <div data-testid="vendor-profile">
      <h1 className="font-display text-3xl font-bold">Shop Profile</h1>

      <div className="mt-4 rounded-lg border border-neutral-200 bg-white p-6">
        <div className="flex flex-wrap items-center gap-4">
          {user?.picture ? <img src={user.picture} alt="" className="h-16 w-16 rounded-full" /> : <div className="flex h-16 w-16 items-center justify-center rounded-full bg-lime-400 text-2xl font-black">{(user?.name || "V")[0]?.toUpperCase()}</div>}
          <div>
            <div className="font-display text-xl font-bold">{user?.name || "Bhairo Prints"}</div>
            <div className="text-sm text-neutral-500">{user?.email}</div>
            <div className="mt-1 flex items-center gap-2 text-xs text-lime-600"><Star size={12} fill="currentColor" strokeWidth={0} /> {MOCK_STATS_VENDOR.rating} · {MOCK_STATS_VENDOR.reviews} reviews · {MOCK_STATS_VENDOR.onTime}% on-time</div>
          </div>
        </div>

        <div className="mt-6">
          <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">Specialties</label>
          <div className="mt-2 flex flex-wrap gap-2">
            {SPECIALTIES.map((s) => (
              <span key={s} className="rounded-full border border-neutral-300 px-3 py-1 text-xs font-semibold" data-testid={`vp-tag-${s.replace(/\s+/g, "-").toLowerCase()}`}>{s}</span>
            ))}
          </div>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <F label="Shop name" defaultValue={user?.name || "Bhairo Prints"} />
          <F label="Owner name" defaultValue="Bhairo Nath" />
          <F label="Working hours" defaultValue="Mon–Sat · 9AM – 9PM" />
          <F label="Pickup radius (km)" defaultValue="15" />
        </div>

        <button onClick={() => toast.success("Profile saved")} className="btn-offset mt-6 rounded-md bg-neutral-950 px-4 py-2 text-sm font-bold text-white hover:bg-neutral-800" data-testid="vp-save">Save changes</button>
      </div>
    </div>
  );
}

function F({ label, defaultValue }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">{label}</label>
      <input defaultValue={defaultValue} className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm" />
    </div>
  );
}
